const formButtons = {
    init() {
      $(document).on('click', '[id^="nf-label-class-field"][id$="-5"]', function() {
  
        $('.nf-row:eq(1)').addClass('selected');
      });
  
      $(document).on('click', '[id^="nf-label-class-field"]:not([id^="nf-label-class-field"][id$="-5"])', function() {
        $('.nf-row:eq(1)').removeClass('selected');
      }); 
  
      $(document).on('input', '.nf-row.selected input[type="text"]', function() {
        var inputValue = $(this).val();
        var targetRadioButton = $('input[type="radio"][value="other"]');
        targetRadioButton.val(inputValue);
      });
    },
  };
    
  export default formButtons;
    


// WEBPACK FOOTER //
// ./scripts/modules/form-buttons.js